import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const initialState = {
    surchargeDetail: {},
    activeSurchargeDetail: null,
    totalSurchargeAmount: null,
    surchargeLoader: false
};
const baseUrl = process.env.REACT_APP_BASE_URL;

export const evaluateSurcharge = createAsyncThunk(
    "surchargeSlice/evaluateSurcharge",
    async ({ sessionToken, payload } = {}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${baseUrl}/checkout/sessions/${sessionToken}/surcharges/evaluate`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message || "Failed to fetch offers");
        }
    });



export const surchargeSlice = createSlice({
    name: "surchargeSlice",
    initialState,
    reducers: {
        setSurchargeDetails(state, action) {
            state.surchargeDetail = action.payload;
        },
        setSurchargeList(state, action) {
            state.surchargeList = action.payload;
        },
        setActiveSurchargeDetail(state, action) {
            state.activeSurchargeDetail = action.payload
        },
        setTotalSurchargeAmount(state, action) {
            state.totalSurchargeAmount = action.payload
        },

    },
    extraReducers: (builder) => {

        builder
            .addCase(evaluateSurcharge.pending, (state) => {
                state.surchargeLoader = true;
                state.error = null;
            })
            .addCase(evaluateSurcharge.fulfilled, (state, action) => {
                state.surchargeDetail = action.payload;
                state.surchargeLoader = false;
                state.error = null;
            })
            .addCase(evaluateSurcharge.rejected, (state, action) => {
                state.surchargeLoader = false;
                state.error = action.payload || "Something went wrong";
            })

    }
});

export const { setSurchargeDetails, setSurchargeList, setActiveSurchargeDetail, setTotalSurchargeAmount } = surchargeSlice.actions;

export default surchargeSlice.reducer;


